module.exports = __webpack_public_path__ + "static/media/shiftChangeArrowRed.f8298931.svg";